import { invokeApi } from "../utils/api";
import { $axios } from "../utils/axios";

export const serviceCenterContact = () =>
	invokeApi($axios, "/servicecenter/contact", {}, "GET")
		.then((resp) => resp)
		.catch((err) => {
			throw err;
		});

export const serviceCenterSingleContact = (id, softdelete) =>
	invokeApi(
		$axios,
		`/servicecenter/contact/${softdelete === "true" ? "soft-delete/" : ""}${id}`,
		{},
		"GET"
	)
		.then((resp) => resp)
		.catch((err) => {
			throw err;
		});

export const softDeleteServiceCenterSingleContact = (id, reason) =>
	invokeApi($axios, `/servicecenter/contact/soft-delete/${id}?reason=${reason}`, {}, "DELETE")
		.then((resp) => resp)
		.catch((err) => {
			throw err;
		});
